import * as i0 from '@angular/core';
import { forwardRef, EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
const _c0 = (a0, a1, a2) => ({
  "p-inputswitch p-component": true,
  "p-inputswitch-checked": a0,
  "p-disabled": a1,
  "p-focus": a2
});
const INPUTSWITCH_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputSwitch),
  multi: true
};
let InputSwitch = /*#__PURE__*/(() => {
  class InputSwitch {
    constructor(cd) {
      this.cd = cd;
      this.trueValue = true;
      this.falseValue = false;
      this.onChange = new EventEmitter();
      this.modelValue = false;
      this.focused = false;
      this.onModelChange = () => {};
      this.onModelTouched = () => {};
    }
    onClick(event, cb) {
      if (!this.disabled && !this.readonly) {
        event.preventDefault();
        this.toggle(event);
        cb.focus();
      }
    }
    onInputChange(event) {
      if (!this.readonly) {
        const inputChecked = event.target.checked;
        this.updateModel(event, inputChecked);
      }
    }
    toggle(event) {
      this.updateModel(event, !this.checked());
    }
    updateModel(event, value) {
      this.modelValue = value ? this.trueValue : this.falseValue;
      this.onModelChange(this.modelValue);
      this.onChange.emit({
        originalEvent: event,
        checked: this.modelValue
      });
    }
    onFocus(event) {
      this.focused = true;
    }
    onBlur(event) {
      this.focused = false;
      this.onModelTouched();
    }
    writeValue(value) {
      this.modelValue = value;
      this.cd.markForCheck();
    }
    registerOnChange(fn) {
      this.onModelChange = fn;
    }
    registerOnTouched(fn) {
      this.onModelTouched = fn;
    }
    setDisabledState(val) {
      this.disabled = val;
      this.cd.markForCheck();
    }
    checked() {
      return this.modelValue === this.trueValue;
    }
  }
  InputSwitch.ɵfac = function InputSwitch_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InputSwitch)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  InputSwitch.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InputSwitch,
    selectors: [["p-inputSwitch"]],
    hostAttrs: [1, "p-element"],
    inputs: {
      style: "style",
      styleClass: "styleClass",
      tabindex: "tabindex",
      inputId: "inputId",
      name: "name",
      disabled: "disabled",
      readonly: "readonly",
      trueValue: "trueValue",
      falseValue: "falseValue",
      ariaLabel: "ariaLabel",
      ariaLabelledBy: "ariaLabelledBy"
    },
    outputs: {
      onChange: "onChange"
    },
    features: [i0.ɵɵProvidersFeature([INPUTSWITCH_VALUE_ACCESSOR])],
    decls: 5,
    vars: 16,
    consts: [["cb", ""], [3, "click", "ngClass", "ngStyle"], [1, "p-hidden-accessible"], ["type", "checkbox", "role", "switch", 3, "change", "focus", "blur", "checked", "disabled"], [1, "p-inputswitch-slider"]],
    template: function InputSwitch_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵlistener("click", function InputSwitch_Template_div_click_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          const cb_r2 = i0.ɵɵreference(3);
          return i0.ɵɵresetView(ctx.onClick($event, cb_r2));
        });
        i0.ɵɵelementStart(1, "div", 2)(2, "input", 3, 0);
        i0.ɵɵlistener("change", function InputSwitch_Template_input_change_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onInputChange($event));
        })("focus", function InputSwitch_Template_input_focus_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onFocus($event));
        })("blur", function InputSwitch_Template_input_blur_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onBlur($event));
        });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.styleClass);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c0, ctx.checked(), ctx.disabled, ctx.focused))("ngStyle", ctx.style);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("checked", ctx.checked())("disabled", ctx.disabled);
        i0.ɵɵattribute("aria-label", ctx.ariaLabel)("id", ctx.inputId)("name", ctx.name)("tabindex", ctx.tabindex)("aria-checked", ctx.checked())("aria-labelledby", ctx.ariaLabelledBy);
      }
    },
    dependencies: [i1.NgClass, i1.NgStyle],
    styles: [".p-inputswitch{position:relative;display:inline-block;-webkit-user-select:none;user-select:none}.p-inputswitch-slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0}.p-inputswitch-slider:before{position:absolute;content:\"\";top:50%}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
  return InputSwitch;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputSwitchModule = /*#__PURE__*/(() => {
  class InputSwitchModule {}
  InputSwitchModule.ɵfac = function InputSwitchModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InputSwitchModule)();
  };
  InputSwitchModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: InputSwitchModule
  });
  InputSwitchModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return InputSwitchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { INPUTSWITCH_VALUE_ACCESSOR, InputSwitch, InputSwitchModule };
